
import { api_host,api_auth} from '../../common/globals/constants';

export const getAudioPatternList = (objective, begin, final, token) => 
fetch(api_host+`/reporte/general/objetivos/${objective}/audios_ivr/list_audios_pattern/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}`)
.then(response => response.json())
